export type Theme = 'light' | 'dark';
export const THEME_KEY = 'pm-chat:theme';

// A browser preference applies to login and recovery screens as well as authenticated UI.
export function readTheme(getItem: (key: string) => string | null): Theme {
  try { return getItem(THEME_KEY) === 'dark' ? 'dark' : 'light'; }
  catch { return 'light'; }
}

export function saveTheme(theme: Theme, setItem: (key: string, value: string) => void): boolean {
  try { setItem(THEME_KEY, theme); return true; }
  catch { return false; }
}

// Shared by the tiny blocking shell entry and normal app startup (including older cached shells).
export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#18232e' : '#176b91');
}
